<template>
  <form
    class="representative-type-selector"
    @submit.prevent="submit"
  >
    <v-row>
      <v-col :cols="shouldAddAlreadyExistsCaseParty ? 4 : null">
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="form.representativeRole"
          :items="representativesList"
          item-value="id"
          item-text="title"
          validates="required"
          :placeholder="local.common.representativeRole"
        ></naj-input>
      </v-col>
      <v-col
        v-if="shouldAddAlreadyExistsCaseParty"
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="form.casePartyObjectKey"
          :items="casePartiesDropDownList"
          item-value="objectKey"
          item-text="name"
          :placeholder="`إضافة ${representativeRoleName}`"
        ></naj-input>
      </v-col>
      <v-col
        v-if="showRepresentativeType"
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="form.representativePartyType"
          :items="representativesTypeList"
          item-text="name"
          item-value="id"
          validates="required"
          :placeholder="local.common.representativePartyType"
        ></naj-input>
      </v-col>
      <v-col>
        <naj-button
          square
          inputs-alignment
          type="submit"
          :disabled="disableSubmitButton"
          :class="`${(showRepresentativeType && shouldAddAlreadyExistsCaseParty) ? 'custom-btn' :''}`"
        >
          {{ local.common.addRepresentative }}
        </naj-button>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { getCasePartyId, isProsecutorRole, isDefendantRole } from '../../helpers/utils';
import { casePartyRoleEnum, casePartyRoleByIdEnum, partyTypeEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
export default {
  props: [
    'relatedCasePartyObjectKey',
    'relatedCasePartyType',
    'relatedCasePartyRole',
    'relatedOfRelatedCasePartyRole',
    'relatedOfRelatedCasePartyType',
  ],
  data() {
    return {
      form: {
        representativeRole: null,
        casePartyObjectKey: null,
        representativePartyType: null,
      },
      casePartyRoleEnum,
      casePartyRoleByIdEnum,
      partyTypeEnum,
      representativeConfig: {
        2: {
          order: 11,
          1: {
            1: true,
            3: true,
            56: {
              1: true,
              2: true,
            },
          },
          3: {
            1: true,
            3: true,
          },
          2: { 10: { 1: true } },
          4: { 10: { 1: true } },
          17: { 10005: { 1: true } },
          18: { 55: { 1: true } },
          19: { 56: { 1: true } },
        },
        5: {
          order: 12,
          1: {
            1: true,
            3: true,
            56: {
              1: true,
              2: true,
            },
          },
          9: { 1: true },
          3: {
            1: true,
            3: true,
          },
          2: {
            1: true,
            10: { 1: true },
          },
          4: { 10: { 1: true } },
          17: { 10005: { 1: true } },
          18: {
            55: {
              1: true,
              2: true,
            },
          },
          19: {
            56: {
              1: true,
              2: true,
            },
          },
        },
        10: {
          order: 10,
          1: {
            56: {
              2: true,
              4: true,
            },
            1: true,
            3: true,
          },
          2: {
            1: true,
            3: true,
          },
          3: {
            1: true,
            3: true,
          },
          4: {
            1: true,
            3: true,
          },
          5: {
            1: true,
            3: true,
          },
          6: {
            1: true,
            3: true,
          },
          15: {
            1: true,
            3: true,
          },
          7: {
            1: true,
            3: true,
          },
          8: {
            1: true,
            3: true,
          },
          9: {
            1: true,
            3: true,
          },
          17: {
            10005: {
              4: true,
              6: true,
            },
          },
          18: {
            55: {
              2: true,
              4: true,
            },
          },
          19: {
            56: {
              2: true,
              4: true,
            },
          },
        },
        11: {
          order: 13,
          1: {
            1: true,
            3: true,
          },
        },
        55: {
          order: 15,
          18: {
            1: true,
            3: true,
            representativePartyType: {
              1: true,
              2: true,
              4: true,
            },
          },
        },
        56: {
          order: 16,
          1: {
            1: true,
            3: true,
            representativePartyType: {
              1: true,
              2: true,
              4: true,
            },
          },
          19: {
            1: true,
            3: true,
            representativePartyType: {
              1: true,
              2: true,
              4: true,
            },
          },
        },
        10005: {
          order: 17,
          17: {
            1: true,
            3: true,
            representativePartyType: {
              1: true,
              2: true,
              3: true,
              4: true,
              6: true,
            },
          },
        },
      },
      filteredPartyTypes: null,
      selectedRepresentativeType: null,
    };
  },
  computed: {
    ...mapGetters([
      'prosecutorPersonsDropDownList',
      'defendantPersonsDropDownList',
      'prosecutors',
      'defendants',
    ]),
    ...mapLUTState(['partyTypes']),
    showPersonAsOrganizationOwner() {
      return (this.form || {}).representativeRole == this.casePartyRoleEnum.cessationObserver;
    },
    shouldAddAlreadyExistsCaseParty() {
      return this.form.representativeRole && this.casePartiesDropDownList.length > 1;
    },
    representativeRoleName() {
      return this.local.common.casePartyRoles[
        this.casePartyRoleByIdEnum[this.form.representativeRole]
      ];
    },
    representativesList() {
      return Object.keys(this.representativeConfig)
        .filter((key) => {
          const ct = this.representativeConfig[key];
          return (
            ct[this.relatedOfRelatedCasePartyType] && ct[this.relatedOfRelatedCasePartyType][this.relatedCasePartyRole] &&
            (this.relatedCasePartyType ? ct[this.relatedOfRelatedCasePartyType][this.relatedCasePartyRole][this.relatedCasePartyType] : ct[this.relatedOfRelatedCasePartyType][this.relatedCasePartyRole])
          );
        })
        .map(key => ({
          id: key,
          title: this.local.common.casePartyRoles[casePartyRoleByIdEnum[key]],
          order: this.representativeConfig[key].order,
        }))
        .sort((a, b) => a.order - b.order);
    },
    representativesTypeList() {
      return Object.keys(this.representativeConfig)
        .filter((key) => {
          const ct = this.representativeConfig[key];
          if (ct[this.relatedOfRelatedCasePartyType] &&
            ct[this.relatedOfRelatedCasePartyType][this.relatedCasePartyRole] && ct[this.relatedOfRelatedCasePartyType]['representativePartyType'])
            this.selectedRepresentativeType = key;
          return (
            ct[this.relatedOfRelatedCasePartyType] &&
            ct[this.relatedOfRelatedCasePartyType][this.relatedCasePartyRole] && ct[this.relatedOfRelatedCasePartyType]['representativePartyType']
          );
        })
        .map(key => (this.partyTypes.filter(a => this.representativeConfig[key][this.relatedOfRelatedCasePartyType]['representativePartyType'][a.id])
          .map(partyType => ({
            id: partyType.id,
            name: (this.showPersonAsOrganizationOwner && partyType.id == partyTypeEnum.person) ? partyType.name : (partyType.id == partyTypeEnum.person) ? this.local.common.person : partyType.name,
          }))
        ))
        .flat();
    },
    casePartiesDropDownList() {
      let list = [];
      if (
        isProsecutorRole(this.relatedCasePartyRole) ||
        isProsecutorRole(this.relatedOfRelatedCasePartyRole)
      ) { list = this.prosecutorPersonsDropDownList; } else if (
        isDefendantRole(this.relatedCasePartyRole) ||
        isDefendantRole(this.relatedOfRelatedCasePartyRole)
      ) { list = this.defendantPersonsDropDownList; }

      const caseParties = {
        ...this.prosecutors,
        ...this.defendants,
      };

      let relatedCaseParty = caseParties[this.relatedCasePartyObjectKey];

      if (!relatedCaseParty) {
        relatedCaseParty = Object.values(caseParties)
          .find(
            cp => cp.representatives[this.relatedCasePartyObjectKey]
          );
      }

      list = list.filter(
        c =>
          c.objectKey !== this.relatedCasePartyObjectKey &&
          c.objectKey !== relatedCaseParty.objectKey &&
          !Object.values(relatedCaseParty.representatives)
            .some(
              r =>
                getCasePartyId(r).uniqueId === c.uniqueId ||
                Object.values(r.representatives)
                  .some(
                    r2 => getCasePartyId(r2).uniqueId === c.uniqueId
                  )
            )
      );

      list.unshift({
        objectKey: null,
        name: `إضافة ${this.representativeRoleName} جديد`,
      });

      return list;
    },
    disableSubmitButton() {
      return ((this.representativesTypeList && this.representativesTypeList.length > 0 && !this.form.casePartyObjectKey && this.selectedRepresentativeType == this.form.representativeRole) ? !this.form.representativePartyType || !this.form.representativeRole : !this.form.representativeRole);
    },
    showRepresentativeType() {
      return (this.representativesTypeList && this.representativesTypeList.length > 0 && !this.form.casePartyObjectKey && this.selectedRepresentativeType == this.form.representativeRole);
    },
  },
  mounted() {
    this.getPartyTypes();
    this.$emit('show', !!this.representativesList.length);

  },
  methods: {
    ...mapLUTActions(['getPartyTypes']),
    ...mapActions(['openAddExistCasePartyAsRepresentative', 'openAddCasePartyRepresentative']),
    submit() {
      this.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            if (this.form.casePartyObjectKey) {
              this.openAddExistCasePartyAsRepresentative({
                casePartyObjectKey: this.relatedCasePartyObjectKey,
                casePartyRepresentativeRole: this.form.representativeRole,
                casePartyRepresentativeObjectKey: this.form.casePartyObjectKey,
                casePartyRepresentativePartyType: this.form.representativePartyType,
              });
            } else {
              this.openAddCasePartyRepresentative({
                casePartyObjectKey: this.relatedCasePartyObjectKey,
                casePartyRepresentativeRole: this.form.representativeRole,
                casePartyRepresentativePartyType: this.form.representativePartyType,
              });
            }
          }
        });
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep .v-input,
::v-deep .v-btn {
  margin: 0 !important;
  height: 0 !important;
}
.custom-btn {
  margin: 50px 0px 0px !important;
  height: 0 !important;
}
</style>
